import { useLocation } from "react-router-dom";
import useDriversPage from "../pageHooks/useDriversPage";
import DriversPageContent from "./DriversPageContent";

export default function AdminProfessionalDrivers() {
    const location = useLocation();
    const {
        filterModalOpen,
        setFilterModalOpen,
        driversList,
        fetchDriversError,
        paginationState,
        handleFetchDrivers,
        isFetchingDrivers,
        driverPageLocation,
        driverStatsData,
        isLoadingDriverStats,
        employmentFilters,
        query,
        setQuery,
    } = useDriversPage(location.pathname);

    return (
        <DriversPageContent
            title="Professional Drivers"
            driverPageLocation={driverPageLocation}
            filterModalOpen={filterModalOpen}
            setFilterModalOpen={setFilterModalOpen}
            paginationState={paginationState}
            handleFetchDrivers={handleFetchDrivers}
            isFetchingDrivers={isFetchingDrivers}
            driversList={driversList}
            fetchDriversError={fetchDriversError}
            driversStats={driverStatsData}
            isGettingAllDriversStats={isLoadingDriverStats}
            employmentFilters={employmentFilters}
            query={query}
            setQuery={setQuery}
        />
    );
}
